import { CardTokenResponse } from '@core/models';
import { Observable } from 'rxjs';
import {
	CheckoutAssociatedCardGateway,
	CheckoutAssociatedCardRequest,
	CheckoutAssociatedCardStrategy,
} from '../interfaces/checkout-credit-card.interface';

export class LoggedInAssociatedCardStrategy implements CheckoutAssociatedCardStrategy {
	create(
		request: CheckoutAssociatedCardRequest,
		gateway: CheckoutAssociatedCardGateway
	): Observable<CardTokenResponse> {
		if (!request.customerMerchId) {
			throw new Error('customerMerchId is required for logged-in users');
		}

		return gateway.createLoggedIn(request.token, request.customerData, request.customerMerchId);
	}
}
